exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!air-datepicker/dist/css/datepicker.min.css"), "");

// module
exports.push([module.id, "\n.input-text-icon[data-v-648bf59c] {\n  float: right;\n  margin-right: 1rem;\n  margin-top: -2.15rem;\n  position: relative;\n  font-size: 120%;\n  z-index: 2;\n  color: #9E9E9E;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-648bf59c","scoped":true,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/chatBooking/components/ServiceRequestFirstMessage.vue
// module id = 2250
// module chunks = 0